export type IncidentOption = {
  label: string
  value: string
  description?: string
}

export type IncidentOptionGroup = {
  options: IncidentOption[]
  allowOther?: boolean
}

export const injuryOptions: IncidentOptionGroup = {
  options: [
    { label: 'TBI — mild (concussion)', value: 'tbi-mild' },
    { label: 'TBI — severe', value: 'tbi-severe' },
    { label: 'Spine — neck', value: 'spine-neck' },
    { label: 'Spine — upper / mid back', value: 'spine-upper-mid-back' },
    { label: 'Spine — lower back', value: 'spine-lower-back' },
    { label: 'Shoulder', value: 'shoulder' },
    {
      label: 'Arm / elbow / wrist / fingers',
      value: 'arm-elbow-wrist-fingers',
    },
    {
      label: 'Hip / knee / lower leg / foot',
      value: 'hip-knee-lower-leg-foot',
    },
    { label: 'Chest / abdomen', value: 'chest-abdomen' },
  ],
}

export const surgeryOptions: IncidentOptionGroup = {
  options: [
    { label: 'Ostomy bag', value: 'ostomy-bag' },
    { label: 'PEG tube', value: 'peg-tube' },
    { label: 'RIG tube', value: 'rig-tube' },
    { label: 'J tube', value: 'j-tube' },
    { label: 'Tracheostomy (placed)', value: 'tracheostomy-placed' },
    { label: 'Tracheostomy (removed)', value: 'tracheostomy-removed' },
    { label: 'Feeding tube removed', value: 'feeding-tube-removed' },
    { label: 'Back / neck surgery', value: 'back-neck-surgery' },
    { label: 'Limb / joint — upper', value: 'limb-joint-upper' },
    { label: 'Limb / joint — lower', value: 'limb-joint-lower' },
    { label: 'Appendix removed', value: 'appendix-removed' },
    { label: 'Gall bladder removed', value: 'gall-bladder-removed' },
    { label: 'Spleen removed', value: 'spleen-removed' },
    { label: 'Tonsils / adenoids removed', value: 'tonsils-adenoids-removed' },
    { label: 'Eye surgery', value: 'eye-surgery' },
    { label: 'Cancer-related surgery', value: 'cancer-related-surgery' },
    {
      label: 'Heart surgery / stent / pacemaker / bypass',
      value: 'heart-surgery-stent-pacemaker-bypass',
    },
    { label: 'Lymph nodes removed (some)', value: 'lymph-nodes-removed-some' },
    { label: 'Organ replacement', value: 'organ-replacement' },
    { label: 'Other', value: 'other' },
  ],
}

export const illnessOptions: IncidentOptionGroup = {
  options: [
    { label: 'COVID-19', value: 'covid-19' },
    { label: 'Influenza (flu)', value: 'influenza' },
    { label: 'Pneumonia', value: 'pneumonia' },
    { label: 'Aspiration pneumonia', value: 'aspiration-pneumonia' },
    { label: 'Respiratory infection (other)', value: 'respiratory-infection' },
    { label: 'Urinary tract infection (UTI)', value: 'uti' },
    { label: 'Gastroenteritis / stomach bug', value: 'gastroenteritis' },
    { label: 'Sepsis / blood infection', value: 'sepsis' },
    { label: 'Skin / pressure wound infection', value: 'skin-wound-infection' },
    { label: 'Other', value: 'other' },
  ],
}

export const stressOptions: IncidentOptionGroup = {
  options: [
    { label: 'Change in social situation', value: 'change-social-situation' },
    { label: 'Change of residence', value: 'change-of-residence' },
    { label: 'Death of a beloved pet', value: 'death-beloved-pet' },
    { label: 'Death of a close friend', value: 'death-close-friend' },
    {
      label: 'Death of close family member',
      value: 'death-close-family-member',
    },
    { label: 'Death of spouse or child', value: 'death-spouse-or-child' },
    { label: 'Divorce or separation', value: 'divorce-or-separation' },
    {
      label: 'Emotional trauma — accident or injury',
      value: 'emotional-trauma-accident-injury',
    },
    { label: 'Family members', value: 'family-members' },
    { label: 'Finances', value: 'finances' },
    { label: 'Job loss', value: 'job-loss' },
    {
      label: 'New family member (marriage, birth, etc.)',
      value: 'new-family-member',
    },
    {
      label: 'Illness / injury — family member',
      value: 'illness-injury-family-member',
    },
    { label: 'Legal difficulties', value: 'legal-difficulties' },
    {
      label: 'Marriage / partner relationship',
      value: 'marriage-partner-relationship',
    },
    { label: 'Natural disaster', value: 'natural-disaster' },
    { label: 'School', value: 'school' },
    { label: 'Sex difficulties', value: 'sex-difficulties' },
    { label: 'Social', value: 'social' },
    { label: 'Child leaving home', value: 'child-leaving-home' },
    {
      label: "Partner's employment change",
      value: 'partners-employment-change',
    },
    { label: 'Holidays / vacation', value: 'holidays-vacation' },
    { label: 'Work / business related', value: 'work-business-related' },
  ],
}
